import { maybe, rd } from '@passionware/monads';
import { FeatureFlag } from '__types__';
import { MergeServices } from 'v5/platform/ts/services';
import { WithFeatureService } from 'v5/services/front/FeatureService/FeatureService';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { myAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService.connected';
import { myFeatureService } from 'v5/services/front/FeatureService/FeatureService.connected';

export type ScopedFeatureFlagServices = MergeServices<
  [WithFeatureService, WithAppScopeService]
>;

/**
 * Enabled Labs / product flag names for the current browsing AppScope.
 * Returns `null` while scope or the flag set is pending — callers should deny.
 */
export function useScopedFeatureFlagNames(
  services: ScopedFeatureFlagServices = {
    featureService: myFeatureService,
    appScopeService: myAppScopeService
  }
): FeatureFlag[] | null {
  const scope = services.appScopeService.useResolvedScopeIdentity();
  const flagsRd = services.featureService.useFeatureFlags(scope);

  if (maybe.isAbsent(scope) || !rd.isSuccess(flagsRd)) {
    return null;
  }

  return Object.entries(flagsRd.data)
    .filter(([, enabled]) => Boolean(enabled))
    .map(([name]) => name as FeatureFlag);
}
